/**
 * Is this route a live session, where app-wide banners and the in-app ring
 * stay out of the way (and the shared poll is suppressed)? One definition
 * for CircleStartBanner and ListenerRingHost, so they never disagree about
 * whether the shared poll should run.
 */
export function isLiveSessionPath(pathname: string): boolean {
  return (
    /\/app\/circles\/\d+$/.test(pathname) ||
    pathname === '/app/ai-buddy' ||
    // The dev Circle Test Room is effectively a live session.
    pathname === '/dev/circle-test-room'
  );
}
